var checkNewIOSSupport = function () {
    return window.webkit && window.webkit.messageHandlers;
};
export var bindGlobalFunc = (function () {
    window.globalFunc = window.globalFunc || {};
    var timer = 10000;
    return function (func) {
        var str = timer++;
        window.globalFunc[str] = func;
        timer++;
        return 'window.globalFunc[' + str + ']';
    };
})();
/**
 * JS与原生交互的管道
 * @param name
 * @param params
 */
export var pipe = function (name, params) {
    params = params || [];
    try {
        if (checkNewIOSSupport()) {
            var handlers = window.webkit.messageHandlers;
            if (handlers[name]) {
                if (!params.length) {
                    params.push('0');
                }
                handlers[name].postMessage(params);
            }
        }
        else if (window.TYSNAV && window.TYSNAV[name]) {
            window.TYSNAV[name].apply(window.TYSNAV, params);
        }
    }
    catch (e) { }
};
/**
 * 判断当前运行环境
 */
export var checkApp = function () {
    var userAgent = window.navigator.userAgent;
    var matched = userAgent.match(/AYKAPP_(\w+)_([\d.]+)/);
    var newUserAgentMatched = userAgent.match(/@([0-9\.]+)@\;/);
    var isApp = !!matched;
    var appVersion = 0;
    var isWeChat = false;
    var isQQ = false;
    var isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    if (matched) {
        appVersion = newUserAgentMatched
            ? parseInt(newUserAgentMatched[1].replace('.', ''))
            : parseInt(matched[0].match(/[\d.]+/)[0].replace('.', ''));
    }
    if (userAgent.indexOf('MicroMessenger') > -1) {
        isWeChat = true;
    }
    return {
        isApp: isApp,
        isWeChat: isWeChat,
        isIOS: isIOS,
        isAndroid: isAndroid,
        appVersion: appVersion
    };
};
export var setShareData = function (options) {
    var desc = options.desc, thumb = options.thumb, title = options.title, url = options.url;
    pipe('setShareData', [desc, desc, thumb, title, url, desc]);
};
export var showLogin = function () { return pipe('showLogin'); };
export var shareToSocialApp = function (options) {
    var desc = options.desc, thumb = options.thumb, title = options.title, url = options.url, type = options.type;
    var params = [desc, desc, thumb, title, url, desc];
    // 默认弹出原生分享框
    var name = 'showSharePopup';
    if (type === 'Wechat')
        name = 'shareToWechatSession';
    if (type === 'WechatMoments')
        name = 'shareToWechatTimeline';
    if (type === 'QQ')
        name = 'shareToQQ';
    if (type === 'QZone')
        name = 'shareToQzone';
    pipe(name, params);
};
/**
 * 禁用iOS滑动返回
 */
export var disableSwipeBack = function () {
    return checkApp().isIOS &&
        pipe('swipeBack', ['0']);
};
/**
 * 启用iOS滑动返回
 */
export var enableSwipeBack = function () {
    return checkApp().isIOS &&
        pipe('swipeBack', ['1']);
};
/**
 * 设置导航栏按钮
 */
export var setTopBarButtons = function (options) {
    var res = options.map(function (el) {
        return [
            {
                name: el.name,
                type: el.type,
                params: el.params,
                onclick: typeof el.onclick === 'function'
                    ? bindGlobalFunc(el.onclick)
                    : ''
            },
        ];
    });
    pipe('setTopBarButtons', [JSON.stringify(res)]);
};
/**
 * 移除导航栏按钮
 */
export var removeTopBarButtons = function () { return pipe('setTopBarButtons'); };
/**
 * 打开评论输入框
 */
export var openCommentBox = function (id, module) {
    return pipe('openCommentBox', [id, module]);
};
/**
 * 打开回复评论
 */
export var replyComment = function (parentId, id, module) {
    pipe('replyComment', [parentId || '', id, module]);
};
/**
 * 打开新窗口
 */
export var openWindow = function (name, obj) {
    return pipe('openWindow', [name, JSON.stringify(obj)]);
};
/**
 * 关闭当前窗口
 */
export var closeWindow = function () { return pipe('closeWindow'); };
/**
 * 获取设备唯一标识符
 */
export var getCurIdentify = function (cb) {
    return pipe('getCurIdentify', [bindGlobalFunc(cb)]);
};
var events = {};
/**
 * 监听App事件
 */
export var onAppEvent = function (event, cb) {
    var isApp = checkApp().isApp;
    if (!events[event]) {
        events[event] = [cb];
        pipe('regEvent', [event]);
    }
    else {
        events[event].push(cb);
    }
};
export var offAppEvent = function (event) {
    delete events[event];
};
window.triggerEvent = function (event, params) {
    if (events[event]) {
        events[event].forEach(function (func) {
            func(JSON.parse(params));
        });
    }
};
/**
 * APP初始化
 * 如果检测到TYSNAV注入完成，触发
 */
export var onAppReady = function (func) {
    if (checkApp().isApp) {
        var timer_1 = function () {
            if (checkNewIOSSupport() || window.TYSNAV) {
                func();
            }
            else {
                window.setTimeout(function () { return timer_1(); }, 200);
            }
        };
        timer_1();
    }
};
/**
 * 登录成功事件
 */
export var onLoginSuccess = function (cb) {
    onAppEvent('login_success', cb);
};
/**
 * 登出成功事件
 */
export var onLogoutSuccess = function (cb) {
    onAppEvent('logout_success', cb);
};
/**
 * 分享完成事件
 */
export var onShareComplete = function (cb) {
    onAppEvent('share_complete', cb);
};
/**
 * 收藏发生改变
 * @param cb
 */
export var onFavoritesChange = function (cb) {
    onAppEvent('favorites_change', cb);
};
/**
 * 显示toast
 */
export var showToast = function (content) {
    pipe('showToast', [content]);
};
/**
 * 设置收藏
 */
export var setFavorites = function (id) {
    pipe('setFavorites', [id + '']);
};
/**
 * 打开图片预览
 */
export var showImgGroup = function (data, index) {
    if (index === void 0) { index = 0; }
    pipe('showImgGroup', [data.length + '', index + '', JSON.stringify(data)]);
};
/**
 * 可能有bug
 */
export var showLoading = function (_a) {
    var msg = _a.msg, isDisableSwipe = _a.isDisableSwipe;
    pipe('showLoading', [msg || '加载中', isDisableSwipe ? '1' : '0']);
};
export var hideLoading = function () { return pipe('hideLoading'); };
//# sourceMappingURL=appHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aiyuke-front-lib/dist/appHelper.js
// module id = null
// module chunks = 